import {useRouter} from "next/router";
import {MenuItems} from "../../data/Menu/Navigation.config";
import {Fragment} from "react";
import IconArrowDown from "../../data/Icons/leon-inmobiliaria-icons-arrow-1-down.svg";
import {useTranslation} from "next-i18next";

interface MobileMenuItemListPropsInterface {
	menuItems: (
		| { label: string; url: string; submenuItems?: undefined }
		| {
		label: string;
		url: string;
		submenuItems: { label: string; url: string }[];
	}
		)[];
	onMenuLevelChange: (selectedMenuLevel: string) => void;
	onClose: () => void;
	languageMenu: boolean;
}

export default function MobileMenuItemList(
	props: MobileMenuItemListPropsInterface
) {
	const router = useRouter();
	const {pathname, asPath, query} = router;
	const {t} = useTranslation();

	return (
		<div className="flex flex-col items-start gap-y-6 h-full">

			<div className="px-8 w-full divide-y grow">
				{MenuItems.find((item) => item.submenuItems === props.menuItems) !=
					undefined && (
						<button
							className="w-full h-12 text-left flex justify-between items-center"
							onClick={() => {
								props.onClose();
								if (
									MenuItems.find((item) => item.submenuItems === props.menuItems)
										?.url
								) {
									router.push(
										MenuItems.find(
											(item) => item.submenuItems === props.menuItems
										)?.url ?? ""
									);
								}
							}}
						>
							{t(
								MenuItems.find((item) => item.submenuItems === props.menuItems)
									?.label!
							)}
							{" Übersicht"}
						</button>
					)}
				{props.menuItems.map((menuItem, idx) => {
					return (
						<Fragment key={idx}>
							<button
								className="w-full h-12 text-left flex justify-between items-center"
								onClick={() => {
									menuItem.submenuItems
										? props.onMenuLevelChange(menuItem.label)
										: props.languageMenu
											? (router.push({pathname, query}, asPath, {
												locale: menuItem.url
											}),
												props.onClose())
											: (router.push(menuItem.url), props.onClose());
								}}
							>
								{t(menuItem.label)}
								{menuItem.submenuItems && (
									<div className="h-3.5 w-3.5 text-leo-button-gray">
										<IconArrowDown className="-rotate-90"/>
									</div>
								)}
							</button>
							<hr className="border-t-px "/>
						</Fragment>
					);
				})}
			</div>
			{props.menuItems != MenuItems && (
				<button
					className="w-full bg-white px-8 h-12 text-left flex gap-x-4 items-center h-20"
					onClick={() => props.onMenuLevelChange("topLevel")}
				>
					<div className="h-3.5 w-3.5 text-leo-button-gray">
						<IconArrowDown className="rotate-90"/>
					</div>
					{t("components.mobileMenuItemList.back")}
				</button>
			)}
		</div>
	);
}
